// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__3YA4W","range":"MonthRangeSwitch_range__2KIjt","disabled":"MonthRangeSwitch_disabled__9DLir"};